const frontRouters = [
  {
    path: "/sheet",
    component: () => import("@/views/Front/Sheet/Layout"),
    name: "sheet",
    redirect: "/sheet/worksheet",
    children: [
      {
        path: "worksheet/:appId/:sheetId?/:viewId?",
        component: () => import("@/views/Front/Sheet/View"),
        name: "worksheet"
      },
      {
        path: "todo/:appId/:id",
        component: () => import("@/views/Front/Sheet/Todo"),
        name: "todo-list"
      },
      {
        path: "url/:appId/:id/:url",
        component: () => import("@/views/Front/Sheet/Url"),
        name: "url"
      },
      {
        path: "statistics-board/:appId/:boardId",
        component: () => import("@/views/Front/Sheet/Statistics/Board"),
        name: "statistics-board"
      }
    ]
  },
  {
    path: "/project",
    component: () => import("@/views/Front/Project/Layout"),
    name: "project",
    children: [
      {
        path: "task-list/:projectId/:taskGroupId?",
        component: () => import("@/views/Front/Project/TaskList"),
        name: "project-task-list"
      },
      {
        path: "overview/:projectId?",
        component: () => import("@/views/Front/Project/Overview"),
        name: "project-overview"
      },
      {
        path: "statistics/:projectId?",
        component: () => import("@/views/Front/Project/Statistics"),
        name: "project-statistics-board"
      },
      {
        path: "task-gantt/:projectId?",
        component: () => import("@/views/Front/Project/Gantt"),
        name: "project-task-gantt"
      },
      {
        path: "project-milestone/:projectId?",
        component: () => import("@/views/Front/Project/Milestone"),
        name: "project-milestone"
      },
      {
        path: "project-risk/:projectId?",
        component: () => import("@/views/Front/Project/Risk"),
        name: "project-risk"
      }
    ]
  }
]

export default frontRouters
